import {Tabs} from "antd";
import React, {useEffect, useState} from "react";
import StudentsView from "./tabs/students.view";
import variables from "../../../_constants/variables";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import TutorsView from "./tabs/tutors.view";
import CounselorsView from "./tabs/counselors.view";
import CentersView from "./tabs/centers.view";
import {useTranslation} from "react-i18next";
import './tutor.scss'
import {dataActions} from "../../../_actions";
import {useDispatch} from "react-redux";


//const pendo = window.pendo;

function Tutor() {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const userType = storage.getItem(variables.USER_TYPE);
    const user = JSON.parse(storage.getItem(variables.USER));
    const [tabData, setTabData] = useState([]);



    useEffect(() => {
/*
        pendo.initialize({
            visitor: {
                id: user.uuid,
                role: userType
            },

            account: {
                id: 1,
                NAME: "Orion",
            },
        });*/

    }, [user])

    useEffect(()=>{

        getCourses();

    },[])

    const getCourses = () => {
        dispatch(dataActions.getCourses());
    };


    useEffect(()=>{
        switch (userType) {
            case 'TUTOR':
                setTabData(
                    [{
                        label: t("menu.students"),
                        key: '1',
                        children: <StudentsView/>,
                    },]
                );
                break;
            case 'COUNSELOR':
                setTabData(
                    [
                        {
                        label: t("menu.students"),
                        key: '1',
                        children: <StudentsView/>,
                    },
                    {
                        label: t("menu.tutores"),
                        key: '2',
                        children: <TutorsView/>,
                    },
                    ]
                );
                break;
            case 'CENTER':
                setTabData(
                    [
                        {
                            label: t("menu.students"),
                            key: '1',
                            children: <StudentsView/>,
                        },
                        {
                            label: t("menu.tutores"),
                            key: '2',
                            children: <TutorsView/>,
                        },
                        {
                            label: t("menu.orienta"),
                            key: '3',
                            children: <CounselorsView/>,
                        },
                    ]
                );
                break;
            case 'MASTER':
                setTabData(
                    [
                        {
                            label: "Alumnos",
                            key: '1',
                            children: <StudentsView/>,
                        },
                        {
                            label: "Tutores",
                            key: '2',
                            children: <TutorsView/>,
                        },
                        {
                            label: "Orientadores",
                            key: '3',
                            children: <CounselorsView/>,
                        },
                        {
                            label: "Centros",
                            key: '4',
                            children: <CentersView/>,
                        },
                    ]
                );
                break;
            default:
                /*@TODO REDIRECT HOME*/
                break;
        }
    }, [userType]);

    const [activeKey, setActiveKey] = useState(userType === "MASTER" ? "4" : userType === "CENTER" ? "3" : userType === "COUNSELOR" ? "2" : "1")

    const onChange = (key) => {
        setActiveKey(key)
    };


    return (

        <div className="container container--informes boxed boxed--informes">
            {tabData &&
                <Tabs className={"tabsViews"}
                      onChange={onChange}
                      activeKey={activeKey}
                      items={tabData}
                />
            }

        </div>
    );
}

export default Tutor;
